import styled from 'styled-components';
import { slideInRight } from 'Styles/effects';

export const ItemWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 42px;
  display: flex;
  align-items: center;
  padding-left: 23px;
  padding-right: 12px;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.buttons.sidebar.hover};
  }


    
    ${({ selected, theme }) => selected && `
      background-color: ${theme.buttons.sidebar.selected};
  `}
`;

export const Wrapper = styled.div`
  position: relative;
`;

export const Text = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  margin-left: 13px;
  font-size: 15px;
  color: ${({ theme }) => theme.buttons.sidebar.text};
  width: auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${slideInRight}
  
  ${({ selected }) => selected &&
  `
    font-weight: 600;
  `}
`;

export const IconSlot = styled.div`
  position: relative;
  width: 22px;
  height: 22px;
  flex: 0 0 22px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Icon = styled.div`
  width: 22px;
  display: flex;
  justify-content: center;
  &:not(.reports) svg {
    width: 22px;
  }
  svg > path {
    fill: ${({ theme }) => theme.icons.sideBar.color};
    ${({ name, theme }) => name === 'Notifications' &&
    `
      stroke: ${theme.icons.sideBar.color} !important;
      fill: transparent !important;
    `}
  }
  svg > path[stroke] {
    stroke: ${({ theme }) => theme.icons.sideBar.color};
    fill: none;
    ${({ selected, theme }) => selected && `
      stroke: ${theme.icons.sideBar.selected};
    `}
  }
  svg > g :last-child {
    fill: ${({ theme }) => theme.icons.sideBar.color};
    ${({ selected, theme }) => selected && `
      fill: ${theme.icons.sideBar.selected};
    `}
  }
  .reports {
    margin-left: 3px;
  }
  .kb {
    margin-left: 3px;
  }
`;

export const CompactBadgeWrapper = styled.div`
  position: absolute;
  top: -10px;
  right: -12px;
  z-index: 1;
`;

export const ExpandedBadgeWrapper = styled.div`
  flex: 0 0 auto;
  margin-left: 8px;
`;
